/**
 * User: n.gorte
 * Date: 12.04.2019
 * Time: 12:38
 */
'use strict';


export const FliwasCanvasRenderer = L.Canvas.extend({

    onAdd(map) {
        L.Renderer.prototype.onAdd.call(this, map);
        // add this renderer so the map can quickly reference it
        this._map._registerCanvasRenderer(this);

        this._draw();
    },

    onRemove(map) {
        L.Renderer.prototype.onRemove.call(this);
        this.off('update', this._updatePaths, this);
        map._unregisterCanvasRenderer(this);
    },


    _dispatchEvent: function (e) {
        switch (e.type) {
            case 'mousemove':
                this._onMouseMove(e);
                break;
            case 'click':
                this._onClick(e);
                break;
        }
    },

    // Canvas obviously doesn't have mouse events for individual drawn objects,
    // so we emulate that by calculating what's under the mouse on mousemove/click manually
    _onClick(e) {
        const point = this._map.mouseEventToLayerPoint(e);
        let layer, clickedLayer;

        for (let order = this._drawFirst ; order ; order = order.next) {
            layer = order.layer;
            if (layer.options.interactive && layer._containsPoint(point)) {
                if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) {
                    clickedLayer = layer;
                }
            }
        }
        if (clickedLayer) {
            L.DomEvent.fakeStop(e);
            this._fireEvent([ clickedLayer ], e);
        } else {
            // layer wasn't found, send to map to find if other canvas layers can handle event
            // https://inovum-dev.de/jira/browse/FLIWASEN-932
            this._map._forwardCanvasEvent(this, e);
        }
    },

    _handleMouseOut: function(e) {
        var layer = this._hoveredLayer;
        if (layer) {
            // if we're leaving the layer, fire mouseout
            L.DomUtil.removeClass(this._container, 'leaflet-interactive');
            this._fireEvent([ layer ], e, 'mouseout');
            this._hoveredLayer = null;
            this._mouseHoverThrottled = false;
            // fix for https://github.com/elmarquis/Leaflet.GestureHandling/issues/44
            // enabling map interactions after mouseout
            this._map.gestureHandling._handleMouseOver();

        }
    },

    _handleMouseHover: function(e, point) {
        if (this._mouseHoverThrottled) {
            return;
        }
        let layer, candidateHoveredLayer;

        for (let order = this._drawFirst ; order ; order = order.next) {
            layer = order.layer;
            if (layer.options.interactive && layer._containsPoint(point)) {
                candidateHoveredLayer = layer;
            }
        }

        if (candidateHoveredLayer !== this._hoveredLayer) {
            this._handleMouseOut(e);

            if (candidateHoveredLayer) {
                L.DomUtil.addClass(this._container, 'leaflet-interactive'); // change cursor
                this._fireEvent([ candidateHoveredLayer ], e, 'mouseover');
                this._hoveredLayer = candidateHoveredLayer;
            }
        }

        // if no layer was found, forward it to the next canvas renderer if it exists
        if (!candidateHoveredLayer) {
            this._map._forwardCanvasEvent(this, e);
        }

        if (this._hoveredLayer) {
            this._fireEvent([ this._hoveredLayer ], e);
        }

        this._mouseHoverThrottled = true;
        setTimeout((() => {
            this._mouseHoverThrottled = false;
        }), 32);
    },

    _updatePoly: function(layer, closed) {
        if (!this._drawing) {
            return;
        }

        var i, j, len2, p,
            parts = layer._parts,
            len = parts.length,
            ctx = this._ctx;

        if (!len) {
            return;
        }

        ctx.beginPath();
        for (i = 0 ; i < len ; i++) {
            for (j = 0, len2 = parts[i].length ; j < len2 ; j++) {
                p = parts[i][j];
                ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
            }
            if (closed) {
                ctx.closePath();
            }
        }
        this._fillStroke(ctx, layer);

        if (layer.options._dashArray && layer.options.dashStyle) {
            //ctx.beginPath();
            for (i = 0 ; i < len ; i++) {
                for (j = 0, len2 = parts[i].length ; j < len2 ; j++) {
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) {
                    ctx.closePath();
                }
            }
            this._fillDashes(ctx, layer);
        }
    },

    _fillStroke: function(ctx, layer) {
        var options = layer.options;

        if (options.fill) {
            ctx.globalAlpha = options.fillOpacity;
            ctx.fillStyle = options.fillColor || options.color;
            ctx.fill(options.fillRule || 'evenodd');
        }

        if (options.stroke && options.weight !== 0) {
            if (ctx.setLineDash) {
                if (!options.dashStyle) {
                    ctx.setLineDash(layer.options && layer.options._dashArray || []);
                } else {
                    ctx.setLineDash([]);
                }
            }
            ctx.globalAlpha = options.opacity;
            ctx.lineWidth = options.weight;
            ctx.strokeStyle = options.color;
            ctx.lineCap = options.lineCap;
            ctx.lineJoin = options.lineJoin;
            ctx.stroke();
        }
    },

    _fillDashes(ctx, layer) {
        const { options } = layer;
        const { dashStyle } = options;

        if (options.stroke && options.weight !== 0) {
            ctx.setLineDash([ ...options._dashArray ].reverse());
            ctx.globalAlpha = dashStyle.opacity || options.opacity;
            ctx.lineWidth = dashStyle.weight || options.weight;
            ctx.strokeStyle = dashStyle.color || options.color;
            ctx.lineCap = options.lineCap;
            ctx.lineJoin = options.lineJoin;
            ctx.stroke();
        }
    }
});



// WEBPACK FOOTER //
// ./js/FeatureRenderer/FliwasCanvasRenderer.js